<div fxLayout fxLayoutAlign="start center">
  <div style="width: 50px; height: 50px;" fxFlex="none">
    <app-badge *ngIf="!image" [badgeClass]="badgeClass" [text]="badgeContent"></app-badge>
    <div fxLayout fxLayoutAlign="center" style="overflow: hidden; border-radius: 50%;">
      <img height="50px" *ngIf="image" [src]="image">
    </div>

  </div>
  <div fxLayout fxLayoutAlign="start center" style="padding: 10px;">{{text}}</div>
</div>
